import { render } from "./App.vue?vue&type=template&id=237d4aca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=237d4aca&lang=scss"

import exportComponent from "/Users/jiun/Documents/case/2021/BMW/testing/filter/bmw_teaser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__